<template>
  <div class="my-3 mx-4">
    <CSelect
      id="buyer-create-campaign__destination__parsing-type"
      :value.sync="parserType"
      :options="RESPONSE_PARSER_TYPES"
      name="Parsing Type"
      label="Parsing Type"
      horizontal
      small
      required
    />

    <CTextarea
      id="buyer-create-campaign__destination__parsing-expression"
      v-model="parsingValue"
      name="Parsing Expression"
      label="Parsing Expression"
      internal-platform-input
      horizontal
      small
      required
      rows="10"
      :debounce="500"
    >
      <template
        v-if="parserType.toLowerCase() === 'javascript'"
        #preInput
      >
        <code class="code--custom">
          // `input` is the response from the request
          <br>
          function(input) {
        </code>
      </template>

      <template
        v-if="parserType.toLowerCase() === 'javascript'"
        #postInput
      >
        <code class="code--custom">
          }
        </code>
      </template>
    </CTextarea>
  </div>
</template>

<script>
const RESPONSE_PARSER_TYPES = [{
  text: 'JPath',
  value: 'jpath'
},
{
  text: 'XPath',
  value: 'xpath'
},
{
  text: 'Regular Expression',
  value: 'regex'
},
{
  text: 'JavaScript',
  value: 'javascript'
}]


export default {
  name: 'ProgrammaticTargetParserForm',

  props: {
    parser: {
      type: Object,
      default() {
        return {}
      }
    },
  },

  data() {
    return {
      RESPONSE_PARSER_TYPES: Object.freeze(RESPONSE_PARSER_TYPES),
    }
  },

  computed: {
    parserType: {
      get() {
        return this.parser.parserType
      },

      set(value) {
        this.$emit('update', { ...this.parser, parserType: value})
      }
    },

    parsingValue: {
      get() {
        return this.parser.value
      },

      set(value) {
        this.$emit('update', { ...this.parser, value})
      }
    }
  },
}
</script>

<style>

</style>